import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { stages } from './homeData';
import PropTypes from 'prop-types';

const Page6 = ({ setStage }) => {
  const [date, setDate] = useState('');

  function formatExpirationDate(e) {
    // Remove any non-digit characters
    const sanitizedDate = e.target.value?.replace(/\D/g, '');

    // Extract the month and year
    const month = sanitizedDate.slice(0, 2);
    const year = sanitizedDate.slice(2, 4);

    // Return the formatted date
    setDate(`${month}/${year}`);
  }

  return (
    <>
      <Card className="we-card-shadow">
        <Card.Header className="p-4">
          <Card.Title className="text-uppercase mb-0">
            Payment Method
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-4 pt-0 pb-3">
          <Flex className="mb-3 justify-content-between justify-content-md-start">
            <IconButton
              className="fs--1 fw-semi-bold rounded-3 me-3"
              style={{ width: '144px', padding: '10px' }}
              icon="credit-card"
              iconClassName="me-2"
            >
              Credit Card
            </IconButton>
            <IconButton
              variant="outline-secondary"
              className="fs--1 fw-semi-bold border-400 rounded-3 bg-200 hover-bg-primary"
              style={{ width: '144px', padding: '10px' }}
              icon="fa-brands fa-paypal"
              iconClassName="me-2"
            >
              PayPal
            </IconButton>
          </Flex>

          <div className="bg-100 px-3 py-4 rounded-4">
            <Row className="g-3">
              <p className="mb-0 fs-0 fw-semi-bold text-1100">Add new card</p>
              <Form.Group as={Col} md={12} className="mt-2 position-relative">
                <FontAwesomeIcon
                  icon="credit-card"
                  className="card-input-icon fs-1 text-500"
                />
                <Form.Control
                  type="number"
                  className="h-52 ps-5"
                  placeholder="Name on card"
                />
              </Form.Group>
              <Form.Group as={Col} md={6}>
                <Form.Control
                  required
                  type="text"
                  placeholder="MM/YY"
                  className="h-52"
                  value={date}
                  onChange={formatExpirationDate}
                />
                <Form.Control.Feedback type="invalid">
                  EXP DATE required
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md={6}>
                <Form.Control
                  type="number"
                  className="h-52"
                  placeholder="Cvv"
                />
              </Form.Group>
            </Row>
          </div>
          <p className="mt-3">
            Give with confidence. Our secure payment system ensure your personal
            details are kept safe and secure
          </p>
          <Form.Check type="checkbox" id="stay_anonymous" className="my-0">
            <Form.Check.Input type="checkbox" isValid />
            <Form.Check.Label className="ms-1 text-800">
              Use same personal details for payment
            </Form.Check.Label>
          </Form.Check>
        </Card.Body>
      </Card>
      <Flex
        justifyContent="between"
        alignItems="center"
        className={'mt-4 flex-column flex-md-row'}
      >
        <Button
          variant="outline-secondary"
          className="h-52 bg-300 hover-bg-primary border-0 w-215px"
          onClick={() => setStage(stages.Donation1)}
        >
          Cancel
        </Button>
        <Button
          className="h-52 mt-3 mt-md-0 border-0 w-215px"
          onClick={() => setStage(stages.PayNow)}
        >
          Pay Now
        </Button>
      </Flex>
    </>
  );
};
Page6.propTypes = {
  setStage: PropTypes.func.isRequired
};

export default Page6;
